import { PaymentTermsGroup } from '../constants/payment-terms-group.js';
import { PriceAmountType } from '../constants/price-amount-type.js';
/** The four cells every price-sheet node always reports, whether or not a rule actually resolves
 *  one: COD (a real payment term, not a group), the NET wholesale group, then term-agnostic List
 *  and MSRP. COD's key is data-derived (the caller's own COD term id), so this can't be a
 *  module-level constant. Shared by the API's own sheet-cell resolution (resolve-sheet-cell.ts)
 *  and the web price sheet's "rule matched but has no amount" warning-chip check
 *  (price-sheet-columns.tsx's hasUnresolvedBaseCell) so a future PriceAmountType added to one
 *  side can't silently drift from the other. */
export function baseCellKeys(codPaymentTermsId) {
    return [
        {
            amountTypeId: PriceAmountType.WHOLESALE,
            paymentTermsId: codPaymentTermsId,
            paymentTermsGroupId: null,
        },
        {
            amountTypeId: PriceAmountType.WHOLESALE,
            paymentTermsId: null,
            paymentTermsGroupId: PaymentTermsGroup.NET,
        },
        { amountTypeId: PriceAmountType.LIST, paymentTermsId: null, paymentTermsGroupId: null },
        { amountTypeId: PriceAmountType.MSRP, paymentTermsId: null, paymentTermsGroupId: null },
    ];
}
//# sourceMappingURL=base-cell-keys.js.map